import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

var Backdrop = function Backdrop(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      innerRef = _ref.innerRef,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "innerRef"]);

  return React.createElement("div", _extends({
    ref: innerRef,
    className: classNames(baseClassName, className)
  }, props));
};

Backdrop.propTypes = {
  /**
   * Inner ref handler.
   */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(HTMLElement)
  })]),

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
Backdrop.defaultProps = {
  innerRef: null,
  baseClassName: "".concat(CLS_PREFIX, "overlay__backdrop"),
  className: null
};
export default Backdrop;